import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, PROFILE_KEY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProfileContext = createContext(null);

export const ProfileProvider = ({ children }) => {
  const { user } = useAuth();
  const [profiles, setProfiles] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem(PROFILE_KEY) || null);

  const load = useCallback(async () => {
    if (!user) return;
    const { data } = await api.get("/profiles");
    setProfiles(data);
    const stored = localStorage.getItem(PROFILE_KEY);
    if (!stored || !data.some((p) => p.user_id === stored)) {
      localStorage.setItem(PROFILE_KEY, user.user_id);
      setActiveId(user.user_id);
    }
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  const switchProfile = (id) => {
    localStorage.setItem(PROFILE_KEY, id);
    window.location.reload();
  };

  const active = profiles.find((p) => p.user_id === activeId) || profiles.find((p) => p.is_self);

  return (
    <ProfileContext.Provider value={{ profiles, active, activeId, switchProfile, reloadProfiles: load }}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);
